module.exports = __webpack_public_path__ + "assets/img/edit_property.1293019b.png";